import React, { useEffect } from "react";
import { useAuth } from "./AuthContext";
import { useLocation } from "react-router-dom";
import { italyProvinces } from "../utils/italyProvinces";
import ItalyLogin from "../components/ItalyLogin";
import i18next from "i18next";
import { Box, CircularProgress } from "@mui/material";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  const pathSegments = location.pathname.split("/");
  const city = pathSegments[pathSegments.length - 1];

  const isItalianCity =
    city &&
    italyProvinces.some(
      (province) =>
        province.toLowerCase() === decodeURIComponent(city).toLowerCase()
    );

  useEffect(() => {
    if (isItalianCity && i18next.language !== "it") {
      i18next.changeLanguage("it");
    }
  }, [isItalianCity]);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  // Si es una ciudad italiana y no está autenticado, mostrar login
  if (isItalianCity && !currentUser) {
    return <ItalyLogin />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
